// ===== Constants =====

import { HEX_REGEX } from '../constants/generalConstants';

const validHexCode = (hex: string): boolean => HEX_REGEX.test(hex);

export default validHexCode;
